import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LashStudio from "./LashStudio";
import FAQ from "./FAQ";
import Menu from "./price";
import NavBar from "./NavBar";
import Footer from "./Footer";
import "./i18n";

export default function App() {
  return (
    <Router>
      <div className="min-h-screen bg-white">
        <NavBar />
        <Routes>
          <Route path="/" element={<LashStudio />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/menu" element={<Menu />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}